// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Certificates-module--fadeInAnimation--bbadf";
export var grid = "Certificates-module--grid--12c5d";
export var wrapper = "Certificates-module--wrapper--e5cf3";